import { ColumnConfig } from '@/components/table/Table';
import { OfficeApi } from '../models';

export const officesTableColumns: ColumnConfig[] = [
  { label: 'Nombre', field: 'name', sortable: true },
  { label: 'Descripción', field: 'description' },
  { label: 'Dirección', field: 'address', sortable: true },
  {
    label: 'Ciudad',
    field: 'city',
    render: (value: OfficeApi['city']) => value?.name || '-',
  },
];
